"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9967],{

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ol": function() { return /* binding */ ModalCloseButton; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);
/* harmony import */ var _contexts_ModalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84423);






var Modal = function(props) {
    var onChangeModalVisibility = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_ModalContext__WEBPACK_IMPORTED_MODULE_3__/* .ModalContext */ .t);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        onChangeModalVisibility(!props.isHidden);
    }, [
        props.isHidden,
        onChangeModalVisibility
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ModalOverlay, {
        zIndex: props.zIndex,
        isHidden: props.isHidden,
        onClose: props.onClose,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ModalCard, {
            className: props.className,
            children: props.children
        })
    });
};
var ModalOverlay = function(props) {
    if (props.isHidden) {
        return null;
    }
    var _zIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("bottom:0;left:0;right:0;top:0;position:fixed;z-index:", (_zIndex = props.zIndex) !== null && _zIndex !== void 0 ? _zIndex : 100, ";width:100%;height:100%;background-color:rgba(0,0,0,0.3);"),
        onClick: props.onClose,
        children: props.children
    });
};
var ModalCard = function(props) {
    var handleClickCard = function(e) {
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("box-sizing:border-box;position:relative;padding-left:5px;padding-right:5px;position:fixed;height:auto;top:50%;left:50%;transform:translate(-50%,-50%);width:fit-content;max-width:fit-content;"),
        className: props.className,
        onClick: handleClickCard,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
            className: "modal-content",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:5px;padding:24px 32px;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";min-height:150px;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                children: props.children
            })
        })
    });
};
var ModalTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("line-height:24px;margin:0;font-size:16px;text-align:left;color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textStrong */ .O9.textStrong, ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .font.weight.bold */ .LZ.weight.bold, ";"),
        children: props.children
    });
};
var FOCUS_STYLE = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("&:focus-visible{outline:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black10 */ .O9.black10, ";outline-offset:0.15rem;transition:initial;border:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.gray80 */ .O9.gray80, ";}");
var ModalCloseButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("button", {
        "data-test-id": props["data-test-id"],
        onClick: props.onClick,
        className: "close",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:transparent;border:none;border-radius:50%;cursor:pointer;padding:0;appearance:none;width:32px;height:32px;/* ボタン位置の微調整 */\n        position:relative;right:-10px;&:hover{background-color:#d9d9d9;}i.modal-close{font-size:85%;line-height:32px;}", FOCUS_STYLE),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "close1",
            className: "modal-close"
        })
    });
};


/***/ }),

/***/ 95470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ VerticalDivider; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var VerticalDivider = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("height:", props.height, ";width:1px;border-right:1px solid ", props.color || plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";"),
        className: props.className
    });
};


/***/ }),

/***/ 89543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Cover; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var Cover = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("bottom:0;left:0;right:0;top:0;position:fixed;background-color:", props.background || "transparent", ";width:100%;height:100%;z-index:", props.zIndex || 1, "};"),
        className: "cover",
        onClick: props.handleClick
    });
};


/***/ }),

/***/ 13666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Br": function() { return /* binding */ getBlob; },
/* harmony export */   "RH": function() { return /* binding */ callAPIRaw; }
/* harmony export */ });
/* unused harmony exports callAPI, href, endpoint, getCSRFToken */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11987);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);



//TODO penguinのcallAPIとかのほうを使うようにしたいので消したい
var CSRF_TOKEN = getCSRFToken();
function callAPIRaw(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return fetch(endpoint(path), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, options), {
        credentials: "same-origin",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-Token": CSRF_TOKEN
        }
    }));
}
function callAPI(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return callAPIRaw(path, options).then(function(res) {
        return res.json();
    }).then(function(payload) {
        return {
            payload: payload
        };
    }).catch(function(error) {
        return {
            error: error
        };
    });
}
function getBlob(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return callAPIRaw(path, options).then(function(res) {
        return res.blob();
    }).then(function(payload) {
        return {
            payload: payload
        };
    }).catch(function(error) {
        return {
            error: error
        };
    });
}
function href() {
    return typeof location !== "undefined" ? location.href : "";
}
var ENDPOINT_BASE = function(url) {
    var f = url__WEBPACK_IMPORTED_MODULE_0___default().parse(url);
    if (f.protocol && f.host) {
        return "".concat(f.protocol, "//").concat(f.host);
    } else {
        // NOTE: For testing purpose
        return "http://localhost";
    }
}(href());
function endpoint(path) {
    return "".concat(ENDPOINT_BASE).concat(path);
}
function getCSRFToken() {
    // const meta = document.querySelector('meta[name="csrf-token"]');
    // if(!meta){
    //   return ''
    // }
    // return meta.getAttribute('content') || '';
    return "";
}


/***/ }),

/***/ 73153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ SourcingAnnotationCandidateEditModal; }
});

// UNUSED EXPORTS: EditableListItem

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./components/atoms/Modal.tsx
var Modal = __webpack_require__(99338);
;// CONCATENATED MODULE: ./components/pages/companies/components/SourcingAnnotationCandidateDeleteConfirmModal.tsx





var SourcingAnnotationCandidateDeleteConfirmModal = function(props) {
    var ref, ref1, ref2;
    var handleDelete = function() {
        if (props.candidate === null) return;
        props.onDelete(props.candidate.id);
    };
    var handleCancel = function() {
        props.onCancel();
    };
    var description = props.modalName === "マイラベル" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            "全ての企業から「",
            (ref = props.candidate) === null || ref === void 0 ? void 0 : ref.name,
            "」の",
            props.modalName,
            "が削除されます。",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            "この操作は元に戻せません。"
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            "「",
            (ref1 = props.candidate) === null || ref1 === void 0 ? void 0 : ref1.name,
            "」を設定している企業の",
            props.modalName,
            "が未選択になります。",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            "この操作は元に戻せません。"
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* Modal */.u_, {
        isHidden: props.isHidden,
        zIndex: 104,
        onClose: function() {
            props.setDelete(null);
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            "data-test-id": "".concat(props.modalId, "-delete-confirm-modal"),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:space-between;min-height:170px;max-width:522px;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:16px;line-height:150%;letter-spacing:0.02em;margin:0 12px 0 0;word-break:break-all;"),
                    "data-test-id": "delete-confirm-modal-title",
                    children: [
                        "「",
                        (ref2 = props.candidate) === null || ref2 === void 0 ? void 0 : ref2.name,
                        "」を削除しますか？"
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:175%;letter-spacing:0.02em;word-break:break-all;"),
                    "data-test-id": "delete-confirm-modal-description",
                    children: description
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:flex-end;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:4px;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                                className: "cancel",
                                color: "white",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:96px;height:40px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:100%;&.pl-button{padding:0px;}"),
                                onClick: handleCancel,
                                children: "キャンセル"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:4px;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                                "data-test-id": "confirm-delete-".concat(props.modalId),
                                className: "delete",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:", dist/* colors.red60 */.O9.red60, ";border:0px;width:112px;height:40px;&:hover{background:", dist/* colors.red70 */.O9.red70, ";}"),
                                onClick: handleDelete,
                                children: "削除"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/SourcingAnnotationCandidateEditModal.tsx







var ENTER_CODE = "Enter";
var FOCUS_STYLE = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:focus-visible{outline:2px solid ", dist/* colors.black10 */.O9.black10, ";outline-offset:0.15rem;transition:initial;border:1px solid ", dist/* colors.gray80 */.O9.gray80, ";}");
var SourcingAnnotationCandidateEditModal = function(props) {
    var ref = (0,react.useState)(""), newText = ref[0], setNewText = ref[1];
    var ref1 = (0,react.useState)(false), hasEmptyError = ref1[0], setHasEmptyError = ref1[1];
    var ref2 = (0,react.useState)(null), deleteCandidate = ref2[0], setDeleteCandidate = ref2[1];
    var ref3 = (0,react.useState)(false), isComposing = ref3[0], setIsComposing = ref3[1];
    var handleChange = function(text) {
        setNewText(text);
    };
    var handleKeyDown = function(e) {
        if (e.code === ENTER_CODE) {
            e.preventDefault();
            // IME入力中はEnterを無視する
            if (isComposing) return;
            handleAdd();
        }
    };
    var handleAdd = function() {
        addCandidateWithClear(newText);
    };
    var handleDeleteRequest = function(candidate) {
        setDeleteCandidate(candidate);
    };
    var handleDelete = function(candidateId) {
        props.onDelete && props.onDelete(candidateId);
        setDeleteCandidate(null);
    };
    var handleCancel = function() {
        setDeleteCandidate(null);
    };
    var addCandidateWithClear = function(CandidateName) {
        if (validateInput(CandidateName)) {
            props.onCreate(CandidateName);
            setNewText("");
            setHasEmptyError(false);
        } else {
            setHasEmptyError(true);
        }
    };
    var validateInput = function(route) {
        return route.length > 0;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* Modal */.u_, {
                isHidden: props.isHidden,
                zIndex: 104,
                onClose: props.onClose,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;left:50%;top:50%;z-index:102;transform:translate(-50%,-50%);box-sizing:border-box;width:586px;min-height:146px;background:", dist/* colors.white00 */.O9.white00, ";vertical-align:middle;padding:28px 32px 32px;border-radius:8px;"),
                    "data-test-id": "".concat(props.modalId, "-edit-modal"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;margin-bottom:24px;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
                                    "data-test-id": "title",
                                    children: "".concat(props.modalName, "項目を編集")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalCloseButton */.ol, {
                                    "data-test-id": "close",
                                    onClick: props.onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                            "data-test-id": props.modalId,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:left;padding:0;margin:0 0 8px;font-size:14px;max-height:calc(100vh - 124px - 96px);overflow-y:auto;"),
                            children: props.children.length > 0 ? props.children.map(function(route) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditableListItem, {
                                    modalId: props.modalId,
                                    modalName: props.modalName,
                                    onUpdate: props.onUpdate,
                                    onDeleteRequest: handleDeleteRequest,
                                    children: route
                                }, route.id);
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";"),
                                children: "".concat(props.modalName, "項目はまだありません")
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;gap:8px;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    type: "text",
                                    "data-test-id": "new-option",
                                    value: newText,
                                    placeholder: "".concat(props.modalName, "名を入力"),
                                    onChange: function(e) {
                                        return handleChange(e.target.value);
                                    },
                                    onCompositionStart: function() {
                                        return setIsComposing(true);
                                    },
                                    onCompositionEnd: function() {
                                        return setIsComposing(false);
                                    },
                                    onKeyDown: handleKeyDown,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;border:1px solid ", dist/* colors.gray60 */.O9.gray60, ";border-radius:2px;font-size:14px;padding:0 8px 2px;line-height:28px;&::placeholder{color:", dist/* colors.textLight */.O9.textLight, ";font-size:13px;}", FOCUS_STYLE)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                                    size: "small",
                                    "data-test-id": "add-option",
                                    css: FOCUS_STYLE,
                                    onClick: function() {
                                        return handleAdd();
                                    },
                                    children: "追加"
                                })
                            ]
                        }),
                        hasEmptyError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            "data-test-id": "add-error",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:4px 0 0 4px;color:", dist/* colors.red60 */.O9.red60, ";font-size:12px;"),
                            children: "".concat(props.modalName, "名を入力してください")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationCandidateDeleteConfirmModal, {
                isHidden: !deleteCandidate,
                modalId: props.modalId,
                modalName: props.modalName,
                candidate: deleteCandidate,
                setDelete: setDeleteCandidate,
                onDelete: handleDelete,
                onCancel: handleCancel
            })
        ]
    });
};
var ESC_CODE = "Escape";
var COMMIT_TIMEOUT = 1500;
var EditableListItem = function(props) {
    var ref = (0,react.useState)(false), editing = ref[0], setEditing = ref[1];
    var ref1 = (0,react.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    var ref2 = (0,react.useState)(false), committing = ref2[0], setCommitting = ref2[1];
    var ref3 = (0,react.useState)(""), committingValue = ref3[0], setCommittingValue = ref3[1];
    var ref4 = (0,react.useState)(false), isComposing = ref4[0], setIsComposing = ref4[1];
    (0,react.useEffect)(function() {
        clearCommittingState();
    }, [
        props.children
    ]);
    var beginEditing = function() {
        setInputValue(props.children.name);
        setEditing(true);
    };
    var commitEditing = function() {
        props.onUpdate(props.children.id, inputValue);
        setEditing(false);
        // 候補名の変更をリクエストしてから、実際に反映されるまでラグがある。
        // それを解消するために、変更後のテキストを保持しておいて、リクエストが返ってくるまではそれを表示する。
        // もしリクエストが失敗したりタイムアウトした場合は元に戻る。
        setTimeout(clearCommittingState, COMMIT_TIMEOUT);
        setCommitting(true);
        setCommittingValue(inputValue);
    };
    var rollbackEditing = function() {
        setEditing(false);
    };
    var clearCommittingState = function() {
        setCommitting(false);
        setCommittingValue("");
    };
    var handleChange = function(e) {
        setInputValue(e.target.value);
    };
    var handleKeyDown = function(e) {
        switch(e.code){
            case ENTER_CODE:
                e.preventDefault();
                // IME入力中はEnterを無視する
                if (isComposing) return;
                commitEditing();
                break;
            case ESC_CODE:
                rollbackEditing();
                break;
        }
    };
    var handleBlur = function(_e) {
        if (inputValue) {
            commitEditing();
        } else {
            rollbackEditing();
        }
    };
    var handleDelete = function(e, candidate) {
        e.stopPropagation();
        props.onDeleteRequest && props.onDeleteRequest(candidate);
    };
    return editing ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        "data-test-id": "".concat(props.modalId, "-item"),
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:37px;border:1px solid #0071e3;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
            type: "text",
            value: inputValue,
            autoFocus: true,
            onKeyDown: handleKeyDown,
            onChange: handleChange,
            onBlur: handleBlur,
            placeholder: "".concat(props.modalName, "名"),
            onCompositionStart: function() {
                return setIsComposing(true);
            },
            onCompositionEnd: function() {
                return setIsComposing(false);
            },
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.text */.O9.text, ";font-size:14px;letter-spacing:0.018em;width:100%;height:100%;outline:none;border:0;padding-left:7px;padding-bottom:6px;"),
            "data-test-id": "".concat(props.modalId, "-edit-name-input")
        })
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
        "data-test-id": "".concat(props.modalId, "-item"),
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:37px;padding:8px;border-bottom:1px solid ", dist/* colors.border */.O9.border, ";cursor:text;button{opacity:0;}transition:background-color 0.3s ease;&:hover{border-color:", dist/* colors.border */.O9.border, ";background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";button{opacity:1;}}"),
        onClick: function() {
            return beginEditing();
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:1.5;"),
                children: committing ? committingValue : props.children.name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                label: "削除",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    "data-test-id": "delete-".concat(props.modalId),
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;border:0;border-radius:50%;width:32px;height:32px;transition:background-color 0.3s ease;transition:opacity 0.3s ease;cursor:pointer;&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}"),
                    onClick: function(e) {
                        handleDelete(e, props.children);
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "trash-fill",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;border-radius:18px;color:", dist/* colors.textLight */.O9.textLight, ";")
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 26447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MyLabelItem; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);



var MyLabelItem = function(param) {
    var myLabel = param.myLabel, maxWidth = param.maxWidth;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("li", {
        "data-test-id": "my-label-item",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("font-size:12px;line-height:1.5;border-radius:3px;padding:2px 6px;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";border:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.gray50 */ .O9.gray50, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.gray90 */ .O9.gray90, ";display:inline-block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:", maxWidth, ";// TODO:いる？外でやれば良くない？"),
        children: myLabel.name
    });
};


/***/ }),

/***/ 37280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ CompanyFirstInterviewDateCalender; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _atoms_search_DatePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93536);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18584);






var CompanyFirstInterviewDateCalender = function(param) {
    var shortName = param.shortName, firstInterviewDate = param.firstInterviewDate, onSelectFirstInterviewDateBlank = param.onSelectFirstInterviewDateBlank, onSelectFirstInterviewDate = param.onSelectFirstInterviewDate;
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)();
    var handleChangeDatepicker = function(date) {
        if (firstInterviewDate) {
            onSelectFirstInterviewDate(shortName, (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .convertToDateString */ .AH)(date), user);
        }
    };
    var handleDeleteDatepicker = function() {
        if (firstInterviewDate != null) {
            onSelectFirstInterviewDateBlank(shortName, user);
        }
    };
    var tenYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 10));
    var thirtyYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 30));
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("max-height:300px;"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_search_DatePicker__WEBPACK_IMPORTED_MODULE_0__/* .DatePicker */ .M, {
            className: "first-interview-calender",
            selected: firstInterviewDate,
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(".react-datepicker__day--today{border:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.cyan60 */ .O9.cyan60, " !important;color:black !important;}"),
            onChange: handleChangeDatepicker,
            onDelete: handleDeleteDatepicker,
            maxDate: tenYearsFromNow,
            minDate: thirtyYearsAgo
        })
    });
};


/***/ }),

/***/ 78650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ SourcingAnnotationPanel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(24211);
// EXTERNAL MODULE: ./lib/tracking.ts
var tracking = __webpack_require__(56902);
;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/StatusPanelSection.tsx



var StatusPanelSection = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-test-id": "section",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-start;margin-bottom:10px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelSectionLabel, {
                label: label
            }),
            children
        ]
    });
};
var StatusPanelSectionLabel = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        "data-test-id": "label",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:12px;line-height:125%;letter-spacing:0.02em;color:", dist/* colors.textStrong */.O9.textStrong, ";margin-right:12px;min-width:98px;max-width:98px;margin-top:10px;"),
        className: "section-title",
        children: label
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/StatusSection.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  display: flex;\n                  flex-direction: row;\n                  align-items: center;\n                  line-height: 125%;\n                  letter-spacing: 0.02em;\n                  gap: 8px;\n                  font-size: 14px;\n                  color: ",
        ";\n                  cursor: pointer;\n                  padding: 7px 16px 7px 36px;\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      position: absolute;\n                      font-size: 12px;\n                      left: 12px;\n                      z-index: 1;\n                      color: ",
        ";\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      width: 8px;\n                      height: 8px;\n                      border-radius: 50%;\n                      background-color: ",
        ";\n                    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    font-size: 14px;\n                    color: ",
        ";\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var StatusSection = function(param) {
    var shortName = param.shortName, statuses = param.statuses, selectedStatusId = param.selectedStatusId, setSelectedStatusId = param.setSelectedStatusId, onSelectStatus = param.onSelectStatus, onSelectStatusBlank = param.onSelectStatusBlank;
    var currentUser = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(false), statusesOpening = ref[0], setStatusesOpening = ref[1];
    var statusesRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        statusesRef
    ], function() {
        return setTimeout(function() {
            return setStatusesOpening(false);
        }, 100);
    });
    var handleChangeCompanyStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(status) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                onSelectStatus(shortName, status, currentUser);
                setSelectedStatusId(parseInt(status.id));
                (0,tracking/* trackEvent */.L9)(currentUser, tracking/* STATUS_SETTING_ON_STATUS_PANEL */.G$);
                (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_STATUS_SETTING */.nW);
                return [
                    2
                ];
            });
        });
        return function handleChangeCompanyStatus(status) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteCompanyStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                onSelectStatusBlank(shortName, currentUser);
                setSelectedStatusId(undefined);
                (0,tracking/* trackEvent */.L9)(currentUser, tracking/* STATUS_SETTING_ON_STATUS_PANEL */.G$);
                (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_STATUS_SETTING */.nW);
                return [
                    2
                ];
            });
        });
        return function handleDeleteCompanyStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var selectedStatus = statuses.find(function(s) {
        return parseInt(s.id) === selectedStatusId;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelSection, {
        label: "ステータス",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
            ref: statusesRef,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;border:none;align-items:center;padding:7px 4px 7px 10px;gap:4px;border-radius:3px;cursor:pointer;background-color:", statusesOpening ? dist/* colors.gray40 */.O9.gray40 : "transparent", ";&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}position:relative;"),
                    onClick: function() {
                        return setStatusesOpening(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:24px;min-width:24px;max-width:24px;background-color:", selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.color, ";border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:11px;line-height:125%;color:", dist/* colors.white00 */.O9.white00, ";", !selectedStatus && "border: 1px dashed ".concat(dist/* colors.gray70 */.O9.gray70, ";")),
                            className: "status-symbol",
                            children: selectedStatus ? selectedStatus.symbol : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                name: "check1",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray70 */.O9.gray70, ";font-size:16px;")
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(!selectedStatus && "color: ".concat(dist/* colors.gray70 */.O9.gray70), ";font-size:14px;"),
                            className: "status-value",
                            children: selectedStatus ? selectedStatus.name : "（空白）"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "arrow1s-down",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:20px;")
                        })
                    ]
                }),
                statusesOpening && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:216px;max-height:345px;margin-top:7.5px;background:", dist/* colors.white00 */.O9.white00, ";border-radius:2px;box-shadow:0px 0px 10px rgba(0,0,0,0.1);padding:5px 0;position:absolute;list-style:none;white-space:nowrap;transition:0.2s;z-index:50;overflow:auto;li:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}"),
                    className: "statuses",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;align-items:center;line-height:125%;letter-spacing:0.02em;gap:8px;font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";cursor:pointer;padding:7px 16px 7px 36px;"),
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handleDeleteCompanyStatus()
                                            ];
                                        case 1:
                                            _state.sent();
                                            setStatusesOpening(false);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            children: [
                                selectedStatusId === undefined && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "check1",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;font-size:12px;left:12px;z-index:1;color:", dist/* colors.black30 */.O9.black30, ";")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";padding-left:8px;"),
                                    children: "（空白）"
                                })
                            ]
                        }),
                        statuses.map(function(status) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), dist/* colors.black30 */.O9.black30),
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    handleChangeCompanyStatus(status)
                                                ];
                                            case 1:
                                                _state.sent();
                                                setStatusesOpening(false);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    parseInt(status.id) === selectedStatusId && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "check1",
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), dist/* colors.black30 */.O9.black30)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), status.color)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), dist/* colors.black30 */.O9.black30),
                                        className: "status-name",
                                        children: status.name
                                    })
                                ]
                            }, status.id);
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:4px 0;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;align-items:center;line-height:125%;letter-spacing:0.02em;gap:8px;font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";cursor:pointer;padding:7px 16px 7px 36px;position:relative;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:inherit;"),
                                href: url/* statusSettingPath */.Uk,
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "pen-fill",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;left:12px;z-index:1;color:", dist/* colors.gray60 */.O9.gray60, ";")
                                    }),
                                    "ステータス項目を編集"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/ContactPersonSection.tsx



function ContactPersonSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  display: flex;\n                  flex-direction: row;\n                  align-items: center;\n                  line-height: 125%;\n                  letter-spacing: 0.02em;\n                  gap: 8px;\n                  font-size: 14px;\n                  color: ",
        ";\n                  cursor: pointer;\n                  padding: 7px 16px 7px 36px;\n                "
    ]);
    ContactPersonSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactPersonSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      position: absolute;\n                      font-size: 12px;\n                      left: 12px;\n                      z-index: 1;\n                      color: ",
        ";\n                    "
    ]);
    ContactPersonSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactPersonSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    font-size: 14px;\n                    color: ",
        ";\n                    text-overflow: elipsis;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                  "
    ]);
    ContactPersonSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var ContactPersonSection = function(param) {
    var shortname = param.shortname, selectedContactPersonId = param.selectedContactPersonId, contactPeople = param.contactPeople, setSelectedContactPersonId = param.setSelectedContactPersonId, onSelectContactPerson = param.onSelectContactPerson, onSelectContactPersonBlank = param.onSelectContactPersonBlank;
    var ref;
    var currentUser = (0,AuthContext/* useUser */.a)();
    var ref1 = (0,react.useState)(false), contactPersonsOpening = ref1[0], setContactPersonsOpening = ref1[1];
    var ref2 = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        ref2
    ], function() {
        setContactPersonsOpening(false);
    });
    var handleChangeCompanyContactPerson = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(contactPersonId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                onSelectContactPerson({
                    companyId: shortname,
                    userId: contactPersonId,
                    imageUrl: selectContactPerson(contactPersonId).imageUrl,
                    firstName: selectContactPerson(contactPersonId).firstName,
                    lastName: selectContactPerson(contactPersonId).lastName
                }, currentUser);
                setSelectedContactPersonId(contactPersonId);
                (0,tracking/* trackEvent */.L9)(currentUser, tracking/* CONTACT_PERSON_SETTING_ON_STATUS_PANEL */.Yr);
                (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_CONTACT_PERSON_SETTING */.FE);
                return [
                    2
                ];
            });
        });
        return function handleChangeCompanyContactPerson(contactPersonId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteCompanyContactPerson = function() {
        onSelectContactPersonBlank(shortname, currentUser);
        setSelectedContactPersonId();
        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* CONTACT_PERSON_SETTING_ON_STATUS_PANEL */.Yr);
        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_CONTACT_PERSON_SETTING */.FE);
    };
    var selectedContactPerson = contactPeople.find(function(p) {
        return p.userId === selectedContactPersonId;
    });
    var selectContactPerson = function(userId) {
        return contactPeople.find(function(p) {
            return p.userId === userId;
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelSection, {
        label: "担当者",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
            ref: ref2,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;border:none;align-items:center;padding:7px 4px 7px 10px;gap:4px;border-radius:3px;cursor:pointer;background-color:", contactPersonsOpening ? dist/* colors.gray40 */.O9.gray40 : "transparent", ";&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}position:relative;"),
                    onClick: function() {
                        return setContactPersonsOpening(true);
                    },
                    children: [
                        selectedContactPerson ? selectedContactPerson.imageUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            alt: "contact person icon",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:24px;height:24px;object-fit:cover;border-radius:50%;max-width:unset;"),
                            src: selectedContactPerson.imageUrl
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:24px;height:24px;object-fit:cover;border-radius:50%;max-width:unset;display:flex;justify-content:center;align-items:center;background-color:", dist/* colors.blue50 */.O9.blue50, ";font-size:11px;color:", dist/* colors.white00 */.O9.white00, ";"),
                            className: "contact-person-icon",
                            children: (ref = selectedContactPerson.lastName) === null || ref === void 0 ? void 0 : ref.slice(0, 2)
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:24px;height:24px;object-fit:cover;border-radius:50%;max-width:unset;display:flex;justify-content:center;align-items:center;color:", dist/* colors.white00 */.O9.white00, ";border:1px dashed ", dist/* colors.gray70 */.O9.gray70, ";"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                name: "person",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray70 */.O9.gray70, ";font-size:16px;")
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(!selectedContactPerson && "color: ".concat(dist/* colors.gray70 */.O9.gray70), ";font-size:14px;"),
                            className: "contact-person-value",
                            children: selectedContactPerson ? "".concat(selectedContactPerson.lastName, " ").concat(selectedContactPerson.firstName) : "（空白）"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "arrow1s-down",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:20px;")
                        })
                    ]
                }),
                contactPersonsOpening && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:216px;max-height:345px;margin-top:7.5px;background:", dist/* colors.white00 */.O9.white00, ";border-radius:2px;box-shadow:0px 0px 10px rgba(0,0,0,0.1);padding:5px 0;position:absolute;list-style:none;white-space:nowrap;transition:0.2s;z-index:50;overflow:auto;li:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}"),
                    className: "contact-persons",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;align-items:center;line-height:125%;letter-spacing:0.02em;gap:8px;font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";cursor:pointer;padding:7px 16px 7px 36px;"),
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handleDeleteCompanyContactPerson()
                                            ];
                                        case 1:
                                            _state.sent();
                                            setContactPersonsOpening(false);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            children: [
                                selectedContactPersonId === undefined && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "check1",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;font-size:12px;left:12px;z-index:1;color:", dist/* colors.black30 */.O9.black30, ";")
                                }),
                                "（空白）"
                            ]
                        }),
                        contactPeople.map(function(user) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                css: (0,emotion_react_browser_esm/* css */.iv)(ContactPersonSection_templateObject(), dist/* colors.black30 */.O9.black30),
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    handleChangeCompanyContactPerson(user.userId)
                                                ];
                                            case 1:
                                                _state.sent();
                                                setContactPersonsOpening(false);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    user.userId === selectedContactPersonId && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "check1",
                                        css: (0,emotion_react_browser_esm/* css */.iv)(ContactPersonSection_templateObject1(), dist/* colors.black30 */.O9.black30)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "contact-person-name",
                                        css: (0,emotion_react_browser_esm/* css */.iv)(ContactPersonSection_templateObject2(), dist/* colors.black30 */.O9.black30),
                                        children: "".concat(user.lastName, " ").concat(user.firstName)
                                    })
                                ]
                            }, user.userId);
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/pages/companies/components/atom/MyLabelItem.tsx
var MyLabelItem = __webpack_require__(26447);
// EXTERNAL MODULE: ./components/pages/companies/components/tableCell/MyLabelDropdown.tsx + 1 modules
var MyLabelDropdown = __webpack_require__(95397);
;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/MyLabelSection.tsx









var MyLabelSection = function(param) {
    var myLabelIds = param.myLabelIds, myLabels = param.myLabels, onSelectMyLabel = param.onSelectMyLabel, onDeselectMyLabel = param.onDeselectMyLabel, onRequestEditMyLabelModal = param.onRequestEditMyLabelModal;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var wrapperRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        wrapperRef
    ], function() {
        setIsOpen(false);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelSection, {
        label: "マイラベル",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border:none;display:flex;align-items:center;padding:7px 4px 7px 10px;gap:4px;border-radius:3px;cursor:pointer;background-color:", isOpen ? dist/* colors.gray40 */.O9.gray40 : "transparent", ";&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}position:relative;max-width:402px;// TODO:ここは決め打ちしたくなく、いい感じに、こう、幅に合わせて伸びたり縮んだりしてほしいよ"),
                    onClick: function() {
                        setIsOpen(!isOpen);
                    },
                    "data-test-id": "my-label",
                    children: [
                        myLabelIds.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;color:", dist/* colors.gray70 */.O9.gray70, ";"),
                            children: "（空白）"
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;margin:0;white-space:break-spaces;overflow:hidden;display:flex;flex-wrap:wrap;align-items:center;gap:4px;"),
                            children: myLabels.filter(function(it) {
                                return myLabelIds.includes(it.id);
                            }).map(function(it) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelItem/* MyLabelItem */.U, {
                                    myLabel: it,
                                    maxWidth: "100%"
                                }, it.id);
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "arrow1s-down",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:20px;")
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelDropdown/* MyLabelDropdown */.u, {
                    candidates: myLabels,
                    selectedMyLabelIds: myLabelIds,
                    onSelectMyLabel: onSelectMyLabel,
                    onDeselectMyLabel: onDeselectMyLabel,
                    onRequestEditModal: onRequestEditMyLabelModal
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/pages/companies/components/tableCell/SourcingRouteDropdown.tsx
var SourcingRouteDropdown = __webpack_require__(38850);
;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/SourcingRouteSection.tsx










var SourcingRouteSection = function(param) {
    var shortname = param.shortname, selectedSourcingRouteId = param.selectedSourcingRouteId, sourcingRoutes = param.sourcingRoutes, onSelectSourcingRoute = param.onSelectSourcingRoute, onDeselectSourcingRoute = param.onDeselectSourcingRoute, onRequestEditSourcingRouteModal = param.onRequestEditSourcingRouteModal;
    var user = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(false), dropdownOpening = ref[0], setDropdownOpening = ref[1];
    var wrapperRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        wrapperRef
    ], function() {
        setDropdownOpening(false);
    });
    var handleSelectSourcingRoute = function(sourcingRouteId, sourcingRouteName) {
        onSelectSourcingRoute(shortname, sourcingRouteId, sourcingRouteName, user);
        (0,tracking/* trackEvent */.L9)(user, tracking/* SOURCING_ROUTE_SETTING_ON_STATUS_PANEL */.K6);
    };
    var handleDeselectSourcingRoute = function() {
        onDeselectSourcingRoute();
        (0,tracking/* trackEvent */.L9)(user, tracking/* SOURCING_ROUTE_SETTING_ON_STATUS_PANEL */.K6);
    };
    var selectedSourcingRoute = sourcingRoutes.find(function(it) {
        return it.id === selectedSourcingRouteId;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelSection, {
        label: "ソーシングルート",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border:none;display:flex;align-items:center;padding:7px 4px 7px 10px;gap:4px;border-radius:3px;cursor:pointer;background-color:", dropdownOpening ? dist/* colors.gray40 */.O9.gray40 : "transparent", ";&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}position:relative;"),
                    onClick: function() {
                        setDropdownOpening(!dropdownOpening);
                    },
                    "data-test-id": "sourcing-route",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;color:", selectedSourcingRoute ? dist/* colors.black30 */.O9.black30 : dist/* colors.gray70 */.O9.gray70, ";"),
                            children: selectedSourcingRoute ? selectedSourcingRoute.name : "（空白）"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "arrow1s-down",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:20px;")
                        })
                    ]
                }),
                dropdownOpening && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingRouteDropdown/* SourcingRouteDropdown */.B, {
                    sourcingRoutes: sourcingRoutes,
                    selectedSourcingRouteId: selectedSourcingRouteId,
                    onSelectSourcingRoute: handleSelectSourcingRoute,
                    onDeselectSourcingRoute: handleDeselectSourcingRoute,
                    onRequestEditSourcingRouteModal: onRequestEditSourcingRouteModal
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/company.ts
var company = __webpack_require__(10133);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/StatusMemoSection.tsx






function StatusMemoSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      color: ",
        ";\n                    "
    ]);
    StatusMemoSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var MAX_MEMO_INPUT_VALUE = 3000;
var StatusMemoSection = function(param) {
    var shortName = param.shortName, memo = param.memo, onUpdateMemo = param.onUpdateMemo;
    var currentUser = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(memo), editMemo = ref[0], setEditMemo = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isEdit = ref1[0], setIsEdit = ref1[1];
    var ref2 = (0,react.useState)(false), isWarning = ref2[0], setIsWarning = ref2[1];
    var alertLeave = function(event) {
        event.preventDefault();
        event.returnValue = false;
    };
    (0,react.useEffect)(function() {
        setEditMemo(memo);
    }, [
        shortName
    ]);
    (0,react.useEffect)(function() {
        if (isEdit) {
            window.removeEventListener("beforeunload", alertLeave, false);
            window.removeEventListener("popstate", alertLeave, false);
            window.addEventListener("beforeunload", alertLeave, false);
            window.addEventListener("popstate", alertLeave, false);
            router.beforePopState(function() {
                window.removeEventListener("popstate", alertLeave, false);
                if (confirm("このページを離れますか？\n行った変更が保存されない可能性があります。")) return true;
                history.forward();
                router.beforePopState(function() {
                    return false;
                });
                return false;
            });
        }
        return function() {
            window.removeEventListener("beforeunload", alertLeave, false);
            window.removeEventListener("popstate", alertLeave, false);
            router.beforePopState(function() {
                return true;
            });
        };
    }, [
        isEdit
    ]);
    var saveMemo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var ref, userLastName, userFirstName, memoUpdated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsWarning(false);
                if (isInvalidContent(value)) {
                    // バリデーションがエラーになっても入力されたメモをstateに保存しないといけない
                    editMemo ? setEditMemo((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, editMemo), {
                        content: value
                    })) : setEditMemo({
                        content: value,
                        updated: "",
                        lastUpdateUserId: -1,
                        lastName: "",
                        firstName: ""
                    });
                    setTimeout(function() {
                        return setIsEdit(true);
                    }, 100);
                    setIsWarning(true);
                } else {
                    ref = (0,_sliced_to_array/* default */.Z)(currentUser.name.split(" "), 2), userLastName = ref[0], userFirstName = ref[1];
                    memoUpdated = new Date().toISOString();
                    setEditMemo({
                        content: value,
                        updated: memoUpdated,
                        lastUpdateUserId: Number(currentUser.id),
                        lastName: userLastName,
                        firstName: userFirstName
                    });
                    onUpdateMemo(shortName, value);
                    (0,tracking/* trackEvent */.L9)(currentUser, tracking/* MEMO_EDITING */.sj);
                }
                return [
                    2
                ];
            });
        });
        return function saveMemo(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var isInvalidContent = function(content) {
        return content.length > MAX_MEMO_INPUT_VALUE;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:100%;"),
        className: "memo",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:12px;height:16px;display:flex;align-items:center;gap:16px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:12px;line-height:125%;letter-spacing:0.02em;color:", dist/* colors.textStrong */.O9.textStrong, ";"),
                        className: "item-name section-title",
                        children: "メモ"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "updated",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;line-height:150%;letter-spacing:0.02em;color:", dist/* colors.textLight */.O9.textLight, ";"),
                        children: editMemo && editMemo.updated ? "最終編集：".concat((0,date/* convertToJstWithTime */.Ti)(editMemo.updated)) : ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "last-update-user-name",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;line-height:125%;letter-spacing:0.02em;color:", dist/* colors.textLight */.O9.textLight, ";"),
                        children: editMemo ? "".concat(editMemo.lastName, " ").concat(editMemo.firstName) : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:auto;display:flex;flex-direction:column;align-items:center;height:calc(100% - 28px);position:relative;"),
                className: "text",
                children: isEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("textarea", {
                    defaultValue: editMemo ? editMemo.content : undefined,
                    autoFocus: true,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("resize:none;width:512px;height:100%;padding:16px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:150%;letter-spacing:0.02em;bottom:calc(100vh - 24px);&:focus{", isWarning && "outline: 1px ".concat(dist/* colors.red60 */.O9.red60, " solid;\n                  border: none;"), "}"),
                    onFocus: function(e) {
                        return e.currentTarget.setSelectionRange(3000, 3000);
                    },
                    onBlur: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            saveMemo(event.target.value)
                                        ];
                                    case 1:
                                        _state.sent();
                                        setIsEdit(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(event) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;overflow-y:auto;width:512px;height:100%;padding:16px;border:1px solid ", dist/* colors.gray50 */.O9.gray50, ";font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:150%;letter-spacing:0.02em;background-color:", dist/* colors.white00 */.O9.white00, ";white-space:pre-wrap;overflow-wrap:break-word;cursor:text;"),
                    onClick: function() {
                        return setIsEdit(true);
                    },
                    children: (0,company/* splitMemoContentWithHyperLink */.rV)(editMemo).map(function(contentPart, index) {
                        return (0,company/* isHyperLink */.Js)(contentPart) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: contentPart,
                            target: "_blank",
                            css: (0,emotion_react_browser_esm/* css */.iv)(StatusMemoSection_templateObject(), dist/* colors.link */.O9.link),
                            children: contentPart
                        }, index) : contentPart;
                    })
                })
            }),
            isWarning && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;line-height:125%;letter-spacing:0.02em;color:", dist/* colors.red60 */.O9.red60, ";padding-top:8px;padding-bottom:24px;"),
                className: "warning-message",
                children: "保存できる最大文字数を超えています"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/VerticalDivider.tsx
var VerticalDivider = __webpack_require__(95470);
;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/StatusPanelHeader.tsx





var StatusPanelHeader = function(param) {
    var companyName = param.companyName, closePanel = param.closePanel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:48px;display:flex;justify-content:space-between;align-items:center;padding-left:24px;border-bottom:1px solid ", dist/* colors.border */.O9.border, ";"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:16px;line-height:150%;"),
                className: "company-name",
                children: companyName
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:100%;display:flex;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalDivider/* VerticalDivider */.p, {
                        height: "80%"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                        className: "close-icon-tooltip",
                        label: "ステータスパネルを閉じる",
                        place: "bottom",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "close",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:14px;cursor:pointer;"),
                            onClick: closePanel,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                name: "close-panel",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;color:", dist/* colors.text */.O9.text, ";")
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/companies/components/company-firstInterview-date-calender.tsx
var company_firstInterview_date_calender = __webpack_require__(37280);
;// CONCATENATED MODULE: ./components/pages/company/molecules/memo/FirstInterviewDateSection.tsx










var FirstInterviewDateSection = function(param) {
    var shortName = param.shortName, selectedFirstInterviewDate = param.selectedFirstInterviewDate, setSelectedFirstInterviewDate = param.setSelectedFirstInterviewDate, onSelectFirstInterviewDate = param.onSelectFirstInterviewDate, onSelectFirstInterviewDateBlank = param.onSelectFirstInterviewDateBlank;
    var currentUser = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(false), calendarOpening = ref[0], setCalendarOpening = ref[1];
    var firstInterviewDateRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        firstInterviewDateRef
    ], function() {
        setCalendarOpening(false);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelSection, {
        label: "初回面談日",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
            ref: firstInterviewDateRef,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;border:none;align-items:center;padding:7px 4px 7px 10px;gap:4px;border-radius:3px;cursor:pointer;background-color:", calendarOpening ? dist/* colors.gray40 */.O9.gray40 : "transparent", ";&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}position:relative;"),
                    onClick: function() {
                        return setCalendarOpening(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;color:", selectedFirstInterviewDate ? "".concat(dist/* colors.black30 */.O9.black30) : "".concat(dist/* colors.gray70 */.O9.gray70), ";"),
                            className: "first-interview-date",
                            children: (selectedFirstInterviewDate === null || selectedFirstInterviewDate === void 0 ? void 0 : selectedFirstInterviewDate.replace(/-/g, "/")) || "（空白）"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "arrow1s-down",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:20px;")
                        })
                    ]
                }),
                calendarOpening && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;z-index:2;margin-top:7.5px;top:100%;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(company_firstInterview_date_calender/* CompanyFirstInterviewDateCalender */.G, {
                        shortName: shortName,
                        firstInterviewDate: selectedFirstInterviewDate ? new Date(selectedFirstInterviewDate) : new Date(),
                        onSelectFirstInterviewDateBlank: function(shortName) {
                            setCalendarOpening(false);
                            setSelectedFirstInterviewDate(undefined);
                            onSelectFirstInterviewDateBlank(shortName, currentUser);
                            (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_FIRST_INTERVIEW_DATE_SETTING */.OU);
                        },
                        onSelectFirstInterviewDate: function(shortName, firstInterviewDate) {
                            setCalendarOpening(false);
                            setSelectedFirstInterviewDate(firstInterviewDate);
                            onSelectFirstInterviewDate(shortName, firstInterviewDate, currentUser);
                            (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_FIRST_INTERVIEW_DATE_SETTING */.OU);
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/SourcingAnnotationPanel.tsx














var SourcingAnnotationPanel = function(param) {
    var isOpen = param.isOpen, companyShortname = param.companyShortname, myLabels = param.myLabels, sourcingRoutes = param.sourcingRoutes, onSelectStatus = param.onSelectStatus, onSelectStatusBlank = param.onSelectStatusBlank, onSelectContactPerson = param.onSelectContactPerson, onSelectContactPersonBlank = param.onSelectContactPersonBlank, onSelectMyLabel = param.onSelectMyLabel, onDeselectMyLabel = param.onDeselectMyLabel, onRequestEditMyLabelModal = param.onRequestEditMyLabelModal, onSelectFirstInterviewDate = param.onSelectFirstInterviewDate, onSelectFirstInterviewDateBlank = param.onSelectFirstInterviewDateBlank, onSelectSourcingRoute = param.onSelectSourcingRoute, onDeselectSourcingRoute = param.onDeselectSourcingRoute, onRequestEditSourcingRouteModal = param.onRequestEditSourcingRouteModal, onUpdateMemo = param.onUpdateMemo, closePanelProps = param.closePanel;
    var ref = (0,react.useState)({
        companyId: "",
        companyName: "",
        memo: undefined,
        contactPersonId: undefined,
        contactPeople: [],
        statusId: undefined,
        statuses: [],
        firstInterviewDate: undefined,
        sourcingRouteId: undefined,
        // sourcingRoutes: [],
        myLabelIds: []
    }), annotation = ref[0], setAnnotation = ref[1];
    (0,react.useEffect)(function() {
        if (companyShortname) {
            fetch("/api/pages/companies/".concat(companyShortname, "/sourcing_annotations")).then(function(s) {
                return s.json();
            }).then(function(json) {
                return setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, json), {
                    companyId: json.companyShortName
                }));
            });
        } else {
            setAnnotation({
                companyId: "",
                companyName: "",
                memo: undefined,
                contactPersonId: undefined,
                contactPeople: [],
                statusId: undefined,
                statuses: [],
                firstInterviewDate: undefined,
                sourcingRouteId: undefined,
                // sourcingRoutes: [],
                myLabelIds: []
            });
        }
    }, [
        companyShortname
    ]);
    var closePanel = (0,react.useCallback)(function() {
        closePanelProps();
    }, [
        closePanelProps
    ]);
    var handleSelectSourcingRoute = function(companyId, sourcingRouteId, sourcingRouteName, user) {
        onSelectSourcingRoute(companyId, sourcingRouteId, sourcingRouteName, user);
        setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
            sourcingRouteId: sourcingRouteId
        }));
    };
    var handleDeselectSourcingRoute = function() {
        if (!companyShortname) return;
        onDeselectSourcingRoute(companyShortname);
        setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
            sourcingRouteId: undefined
        }));
    };
    var handleSelectMyLabel = function(myLabelId) {
        if (!companyShortname) return;
        onSelectMyLabel(myLabelId, companyShortname);
        setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
            myLabelIds: (0,_to_consumable_array/* default */.Z)(annotation.myLabelIds).concat([
                myLabelId
            ])
        }));
    };
    var handleDeselectMyLabel = function(myLabelId) {
        if (!companyShortname) return;
        onDeselectMyLabel(myLabelId, companyShortname);
        setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
            myLabelIds: annotation.myLabelIds.filter(function(it) {
                return it !== myLabelId;
            })
        }));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "cover",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("inset:0px;position:fixed;background-color:transparent;width:100vw;height:26vh;z-index:23;"),
                onClick: closePanel
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "status-panel ".concat(isOpen && "open"),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:560px;height:calc(100% - 55px);background-color:", dist/* colors.white10 */.O9.white10, ";position:fixed;top:55px;box-shadow:-8px 8px 16px rgba(0,0,0,0.08);z-index:25;right:-560px;transition:0.5s;margin-top:9px;&.open{right:0px;}"),
                "data-test-id": "status-edit-panel",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusPanelHeader, {
                        companyName: annotation.companyName,
                        closePanel: closePanel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:24px 24px 32px 24px;display:flex;flex-direction:column;height:calc(100vh - 64px - 48px);"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusSection, {
                                shortName: annotation.companyId,
                                statuses: annotation.statuses,
                                selectedStatusId: annotation.statusId,
                                setSelectedStatusId: function(statusId) {
                                    setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
                                        statusId: statusId
                                    }));
                                },
                                onSelectStatus: onSelectStatus,
                                onSelectStatusBlank: onSelectStatusBlank
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactPersonSection, {
                                shortname: annotation.companyId,
                                contactPeople: annotation.contactPeople,
                                selectedContactPersonId: annotation.contactPersonId,
                                setSelectedContactPersonId: function(contactPersonId) {
                                    setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
                                        contactPersonId: contactPersonId
                                    }));
                                },
                                onSelectContactPerson: onSelectContactPerson,
                                onSelectContactPersonBlank: onSelectContactPersonBlank
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelSection, {
                                myLabelIds: annotation.myLabelIds,
                                myLabels: myLabels,
                                onSelectMyLabel: handleSelectMyLabel,
                                onDeselectMyLabel: handleDeselectMyLabel,
                                onRequestEditMyLabelModal: onRequestEditMyLabelModal
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FirstInterviewDateSection, {
                                shortName: annotation.companyId,
                                selectedFirstInterviewDate: annotation.firstInterviewDate,
                                setSelectedFirstInterviewDate: function(firstInterviewDate) {
                                    setAnnotation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, annotation), {
                                        firstInterviewDate: firstInterviewDate
                                    }));
                                },
                                onSelectFirstInterviewDate: onSelectFirstInterviewDate,
                                onSelectFirstInterviewDateBlank: onSelectFirstInterviewDateBlank
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingRouteSection, {
                                shortname: annotation.companyId,
                                selectedSourcingRouteId: annotation.sourcingRouteId,
                                sourcingRoutes: sourcingRoutes,
                                onSelectSourcingRoute: handleSelectSourcingRoute,
                                onDeselectSourcingRoute: handleDeselectSourcingRoute,
                                onRequestEditSourcingRouteModal: onRequestEditSourcingRouteModal
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusMemoSection, {
                                shortName: annotation.companyId,
                                memo: annotation.memo,
                                onUpdateMemo: onUpdateMemo
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 95397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ MyLabelDropdown; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/view/OptionDropdown.tsx
var OptionDropdown = __webpack_require__(96507);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
;// CONCATENATED MODULE: ./components/view/CheckboxDropdownItem.tsx



var CheckboxDropdownItem = function(param) {
    var checked = param.checked, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        "data-test-id": "item",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox, {
            checked: checked,
            onChange: onClick,
            children: children
        })
    });
};
var Checkbox = function(param) {
    var checked = param.checked, children = param.children, onChange = param.onChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;align-items:center;gap:6px;padding:0 12px 0 12px;:hover{background-color:#f1f1f1;}input[type='checkbox']:checked + span{background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border:0;}input[type='checkbox']:checked + span:after{display:block;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:16px;width:16px;margin-right:4px;", checked ? "background: #1F9DB8;" : "background: #ffffff; border: solid 1px ".concat(dist/* colors.border */.O9.border, ";"), "          border-radius:1px;box-sizing:border-box;position:relative;"),
                children: checked ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    className: "check-icon",
                    src: "/static/icomoon/fonts/check.svg",
                    alt: "",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);")
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "parent-name-label",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;height:30px;list-style:none;color:rgb(102,102,102);line-height:100%;width:calc(100% - 25px);"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:20px;line-height:1.5;max-width:275px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"),
                    children: children
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                type: "checkbox",
                checked: checked,
                onChange: onChange,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;")
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/view/OptionDropdownItem.tsx
var OptionDropdownItem = __webpack_require__(51868);
;// CONCATENATED MODULE: ./components/pages/companies/components/tableCell/MyLabelDropdown.tsx






var MyLabelDropdown = function(param) {
    var candidates = param.candidates, selectedMyLabelIds = param.selectedMyLabelIds, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 320 : _maxHeight, tmp = param.position, ref = tmp === void 0 ? {} : tmp, top = ref.top, right = ref.right, bottom = ref.bottom, left = ref.left, onSelectMyLabel = param.onSelectMyLabel, onDeselectMyLabel = param.onDeselectMyLabel, onRequestEditModal = param.onRequestEditModal;
    var isChecked = function(id) {
        return selectedMyLabelIds.includes(id);
    };
    var handleToggleMyLabel = function(id) {
        if (isChecked(id)) {
            onDeselectMyLabel(id);
        } else {
            onSelectMyLabel(id);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionDropdown/* OptionDropdown */.b, {
        dataTestId: "my-label-dropdown",
        open: true,
        hideTopArrow: true,
        _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;min-width:220px;max-height:", maxHeight, "px;overflow-y:auto;", top != null ? "top: ".concat(top, "px;") : "", " ", right != null ? "right: ".concat(right, "px;") : "", " ", bottom != null ? "bottom: ".concat(bottom, "px;") : "", " ", left != null ? "left: ".concat(left, "px;") : ""),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;overflow-y:auto;padding:4px 0;"),
                children: candidates.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:7px 12px 4px 12px;color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;text-align:center;cursor:default;"),
                    children: "まだマイラベル項目はありません"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: candidates.map(function(item, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxDropdownItem, {
                            checked: isChecked(item.id),
                            onClick: function() {
                                return handleToggleMyLabel(item.id);
                            },
                            children: item.name
                        }, "".concat(item.id, "-").concat(i));
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:1;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:4px 0;")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                        dataTestId: "my-label-edit-menu",
                        condition: true,
                        idx: 0,
                        handleSet: function(e) {
                            e.preventDefault();
                            onRequestEditModal();
                        },
                        label: "マイラベル項目を編集",
                        icon: "icon-pen-fill",
                        iconCss: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 38850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ SourcingRouteDropdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18584);
/* harmony import */ var _components_view_OptionDropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96507);
/* harmony import */ var _components_view_OptionDropdownItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51868);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                max-width: 320px;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var SourcingRouteDropdown = function(param) {
    var sourcingRoutes = param.sourcingRoutes, selectedSourcingRouteId = param.selectedSourcingRouteId, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 320 : _maxHeight, tmp = param.position, ref = tmp === void 0 ? {} : tmp, top = ref.top, right = ref.right, bottom = ref.bottom, left = ref.left, onSelectSourcingRoute = param.onSelectSourcingRoute, onDeselectSourcingRoute = param.onDeselectSourcingRoute, onRequestEditSourcingRouteModal = param.onRequestEditSourcingRouteModal;
    // NOTE: ここで useUser() したくない。消したい。
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_components_view_OptionDropdown__WEBPACK_IMPORTED_MODULE_3__/* .OptionDropdown */ .b, {
        dataTestId: "sourcing-route-dropdown",
        _css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;flex-direction:column;min-width:300px;max-height:", maxHeight, "px;overflow-y:auto;", top != null ? "top: ".concat(top, "px;") : "", " ", right != null ? "right: ".concat(right, "px;") : "", " ", bottom != null ? "bottom: ".concat(bottom, "px;") : "", " ", left != null ? "left: ".concat(left, "px;") : ""),
        open: true,
        hideTopArrow: true,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:1;overflow-y:auto;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_view_OptionDropdownItem__WEBPACK_IMPORTED_MODULE_4__/* .OptionDropdownItem */ .$, {
                        label: "（空白）",
                        dataTestId: "sourcing-route-dropdown-item-empty",
                        condition: selectedSourcingRouteId == null,
                        idx: 0,
                        handleSet: function() {
                            onDeselectSourcingRoute(user);
                        }
                    }),
                    sourcingRoutes.map(function(sr, idx) {
                        var isSelected = selectedSourcingRouteId === sr.id;
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_view_OptionDropdownItem__WEBPACK_IMPORTED_MODULE_4__/* .OptionDropdownItem */ .$, {
                            dataTestId: "sourcing-route-dropdown-item",
                            condition: isSelected,
                            idx: idx,
                            handleSet: function(e) {
                                e.preventDefault();
                                onSelectSourcingRoute(sr.id, sr.name, user);
                            },
                            label: sr.name,
                            _css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject())
                        }, sr.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex-shrink:1;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .iz, {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:4px 0;")
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_view_OptionDropdownItem__WEBPACK_IMPORTED_MODULE_4__/* .OptionDropdownItem */ .$, {
                        dataTestId: "sourcing-route-edit-menu",
                        condition: true,
                        idx: 0,
                        handleSet: function(e) {
                            e.preventDefault();
                            onRequestEditSourcingRouteModal();
                        },
                        label: "ソーシングルート項目を編集",
                        icon: "icon-pen-fill",
                        iconCss: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 96507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ OptionDropdown; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);



var OptionDropdown = function(param) {
    var open = param.open, children = param.children, hideTopArrow = param.hideTopArrow, _css = param._css, dataTestId = param.dataTestId;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("ul", {
        "data-test-id": dataTestId,
        className: open ? "option-dropdown is-opening" : "option-dropdown",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("margin-top:7.5px;visibility:", open ? "visible" : "hidden", ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.text */ .O9.text, ";background:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";box-shadow:0px 0px 10px rgba(0,0,0,0.1);border-radius:2px;opacity:", open ? "1" : "0", ";padding:5px 0;position:absolute;list-style:none;min-width:220px;white-space:nowrap;transition:0.2s;z-index:2;", hideTopArrow || "&:before {\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 10px solid #fff;\n        border-bottom-color: #d9d9d9;\n        content: ' ';\n        height: 0;\n        position: absolute;\n        width: 0;\n        top: -10px;\n        left: 13%;\n      }\n      &:after {\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 10px solid #fff;\n        top: -9px;\n        content: ' ';\n        height: 0;\n        position: absolute;\n        width: 0;\n        left: 13%;\n      }", " ", _css),
        children: children
    });
};


/***/ }),

/***/ 51868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OptionDropdownItem; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);



var OptionDropdownItem = function(param) {
    var dataTestId = param.dataTestId, condition = param.condition, idx = param.idx, handleSet = param.handleSet, label = param.label, value = param.value, _css = param._css, icon = param.icon, iconCss = param.iconCss;
    var handleClick = function(e, arg1) {
        e.preventDefault();
        handleSet(e, arg1);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("li", {
        "data-test-id": dataTestId,
        className: condition ? "item is-selected" : "item",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("height:30px;transition:background-color 0.3s ease;&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.backgroundGray */ .O9.backgroundGray, ";}", _css),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("a", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("display:flex;height:100%;line-height:18px;font-size:14px;gap:10px;align-items:center;padding:0 10px 0 10px;overflow:hidden;"),
            onClick: function(e) {
                return handleClick(e, value !== null && value !== void 0 ? value : undefined);
            },
            children: [
                condition ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("i", {
                    className: "icomoon ".concat(icon || "icon-check1"),
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("flex-shrink:1;min-width:14px;", iconCss)
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("flex-shrink:1;min-width:14px;")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("flex:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"),
                    children: label
                })
            ]
        })
    }, "".concat(idx, "-").concat(value));
};


/***/ }),

/***/ 9926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BH": function() { return /* binding */ deleteSourcingRoute; },
/* harmony export */   "PQ": function() { return /* binding */ putSourcingRoute; },
/* harmony export */   "WN": function() { return /* binding */ putStatus; },
/* harmony export */   "Wo": function() { return /* binding */ getSourcingAnnotationCandidates; },
/* harmony export */   "XC": function() { return /* binding */ putMyLabel; },
/* harmony export */   "Y4": function() { return /* binding */ fetchStatusesSSR; },
/* harmony export */   "YB": function() { return /* binding */ putStatusOrder; },
/* harmony export */   "hq": function() { return /* binding */ deleteCompanySourcingRoute; },
/* harmony export */   "i1": function() { return /* binding */ postMyLabel; },
/* harmony export */   "oe": function() { return /* binding */ deleteMyLabel; },
/* harmony export */   "sw": function() { return /* binding */ registerCompanySourcingRoute; },
/* harmony export */   "us": function() { return /* binding */ postSourcingRoute; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79240);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6140);
/* harmony import */ var _components_pages_companies_common_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13666);





var getSourcingAnnotationCandidates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("/api/v1/sourcing_annotations/candidates")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getSourcingAnnotationCandidates() {
        return _ref.apply(this, arguments);
    };
}();
var fetchStatusesSSR = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx) {
        var response, url, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    url = urlOfStatues();
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, url)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        response ? response : {
                            statuses: []
                        }
                    ];
            }
        });
    });
    return function fetchStatusesSSR(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var urlOfStatues = function() {
    return "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/statuses");
};
var putStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(status) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("/api/statuses", {
                            method: "PUT",
                            body: JSON.stringify({
                                name: status.name,
                                statusId: status.id === "" ? null : status.id,
                                color: status.color,
                                symbol: status.symbol
                            })
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function putStatus(status) {
        return _ref.apply(this, arguments);
    };
}();
var putStatusOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(user, order) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("/api/statuses/orders", {
                            method: "PUT",
                            credentials: "include",
                            body: JSON.stringify({
                                contractId: user.contractId,
                                statuses: order
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function putStatusOrder(user, order) {
        return _ref.apply(this, arguments);
    };
}();
var registerCompanySourcingRoute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, sourcingRouteId) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("/api/v1/companies/".concat(shortname, "/sourcing_route"), {
                            method: "PUT",
                            body: JSON.stringify({
                                sourcingRouteId: sourcingRouteId
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function registerCompanySourcingRoute(shortname, sourcingRouteId) {
        return _ref.apply(this, arguments);
    };
}();
var deleteCompanySourcingRoute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("/api/v1/companies/".concat(shortname, "/sourcing_route"), {
                            method: "DELETE"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteCompanySourcingRoute(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var postSourcingRoute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(name) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("/api/v1/sourcing_routes", {
                            method: "POST",
                            body: JSON.stringify({
                                sourcingRouteName: name
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function postSourcingRoute(name) {
        return _ref.apply(this, arguments);
    };
}();
var putSourcingRoute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(id, name) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("/api/v1/sourcing_routes/".concat(id), {
                            method: "PUT",
                            body: JSON.stringify({
                                sourcingRouteName: name
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function putSourcingRoute(id, name) {
        return _ref.apply(this, arguments);
    };
}();
var deleteSourcingRoute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(id) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("/api/v1/sourcing_routes/".concat(id), {
                            method: "DELETE"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteSourcingRoute(id) {
        return _ref.apply(this, arguments);
    };
}();
var postMyLabel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(name) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    (0,_components_pages_companies_common_api__WEBPACK_IMPORTED_MODULE_1__/* .callAPIRaw */ .RH)("/api/v1/my_labels", {
                        method: "POST",
                        body: JSON.stringify({
                            name: name
                        })
                    })
                ];
            } catch (e) {
                (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                return [
                    2,
                    {}
                ];
            }
            return [
                2
            ];
        });
    });
    return function postMyLabel(name) {
        return _ref.apply(this, arguments);
    };
}();
var putMyLabel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(id, name) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_components_pages_companies_common_api__WEBPACK_IMPORTED_MODULE_1__/* .callAPIRaw */ .RH)("/api/v1/my_labels/".concat(id), {
                            method: "PUT",
                            body: JSON.stringify({
                                name: name
                            })
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {}
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function putMyLabel(id, name) {
        return _ref.apply(this, arguments);
    };
}();
var deleteMyLabel = function(id) {
    return (0,_components_pages_companies_common_api__WEBPACK_IMPORTED_MODULE_1__/* .callAPIRaw */ .RH)("/api/v1/my_labels/".concat(id), {
        method: "DELETE"
    }).catch(_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O);
};


/***/ }),

/***/ 10133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ isDomesticCompanyData; },
/* harmony export */   "EC": function() { return /* binding */ isExited; },
/* harmony export */   "Js": function() { return /* binding */ isHyperLink; },
/* harmony export */   "UX": function() { return /* binding */ isResearchDone; },
/* harmony export */   "a5": function() { return /* binding */ isResearchUnvalued; },
/* harmony export */   "hD": function() { return /* binding */ isResearchContinue; },
/* harmony export */   "hv": function() { return /* binding */ isPrivate; },
/* harmony export */   "m8": function() { return /* binding */ checkMemoUpdatedWithinOneWeek; },
/* harmony export */   "rV": function() { return /* binding */ splitMemoContentWithHyperLink; },
/* harmony export */   "sH": function() { return /* binding */ isIPO; },
/* harmony export */   "tP": function() { return /* binding */ companyDefaultImage; },
/* harmony export */   "vg": function() { return /* binding */ companyTabLabel; }
/* harmony export */ });
/* unused harmony exports fetchArticlesByCompany, fetchContentfulCompany, splitMemoContentWithHyperLinkForCompany */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _api_contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58585);
/* harmony import */ var _article__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9427);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79240);







var companyTabLabel = {
    "basic-info": "企業概要",
    "finance-info": "ファイナンス",
    news: "ニュース",
    shareholders: "株主",
    directors: "役員",
    performances: "業績",
    employees: "従業員数",
    partnerships: "提携先",
    benchmarks: "類似企業",
    others: "その他",
    "ipo-data": "IPOデータ"
};
var isDomesticCompanyData = function(company) {
    return typeof company.shortname !== "undefined";
};
var isPrivate = function(company) {
    return company.recordType === "未公開企業";
};
var isIPO = function(company) {
    return company.recordType === "IPO企業";
};
var isResearchContinue = function(company) {
    return isPrivate(company) && /調査継続/.test(company.researchStatus);
};
var isResearchUnvalued = function(company) {
    return isPrivate(company) && /未評価/.test(company.researchStatus);
};
var isExited = function(company) {
    return !!company.exited;
};
var isResearchDone = function(company) {
    return !isResearchContinue(company) && !isResearchUnvalued(company);
};
var companyDefaultImage = function(type) {
    return type === "未公開企業" ? "/static/images/default/company.png" : "/static/images/default/ipo.png";
};
var fetchArticlesByCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(companyId) {
        var articles, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    articles = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticlesByCompany */ .BB)(companyId)
                    ];
                case 2:
                    data = _state.sent();
                    articles = data.items.map(function(res) {
                        return (0,_article__WEBPACK_IMPORTED_MODULE_1__/* .convertArticle */ .AP)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.fields), {
                            id: res.sys.id
                        }));
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_6__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        articles
                    ];
            }
        });
    });
    return function fetchArticlesByCompany(companyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchContentfulCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var company, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    company = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getContentfulCompany */ .kf)(shortname)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        company = data;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_6__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        company
                    ];
            }
        });
    });
    return function fetchContentfulCompany(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var checkMemoUpdatedWithinOneWeek = function(companyMemo) {
    if (companyMemo == null) return false;
    var day = new Date();
    day.setDate(day.getDate() - 7);
    return day < new Date(companyMemo.updated);
};
var splitMemoContentWithHyperLinkForCompany = function(companyMemo) {
    if (!companyMemo || !companyMemo.content) return [];
    var urlRegex = /(https?:\/\/[\w/:%#\$&\?\(\)~\.=\+\-]+)/g;
    var nonUrlRegex = /[^:\w!?/+\-_~;.,*&@#$%()'[\]]+/g;
    if (!urlRegex.test(companyMemo.content)) return [
        companyMemo.content
    ];
    var putContentPart = function(str, contentParts) {
        var idx = str.search(isHyperLink(str) ? nonUrlRegex : urlRegex);
        if (idx === -1) return contentParts.concat(str);
        var firstStr = str.slice(0, idx);
        var secondStr = str.slice(idx);
        return putContentPart(secondStr, contentParts.concat(firstStr));
    };
    return putContentPart(companyMemo.content, []);
};
var splitMemoContentWithHyperLink = function(companyMemo) {
    if (!companyMemo || !companyMemo.content) return [];
    var urlRegex = /(https?:\/\/[\w/:%#\$&\?\(\)~\.=\+\-]+)/g;
    var nonUrlRegex = /[^:\w!?/+\-_~;.,*&@#$%()'[\]]+/g;
    if (!urlRegex.test(companyMemo.content)) return [
        companyMemo.content
    ];
    var putContentPart = function(str, contentParts) {
        var idx = str.search(isHyperLink(str) ? nonUrlRegex : urlRegex);
        if (idx === -1) return contentParts.concat(str);
        var firstStr = str.slice(0, idx);
        var secondStr = str.slice(idx);
        return putContentPart(secondStr, contentParts.concat(firstStr));
    };
    return putContentPart(companyMemo.content, []);
};
var isHyperLink = function(str) {
    return str.startsWith("http");
};


/***/ })

}]);